import { FileClient } from "clients/rest";

export type B100133ExcelRequest = Partial<{
  setshohinCdFrom: string;
  setshohinCdTo: string;
}>;

export const B100133GetExcel = (props: B100133ExcelRequest) => {
  return FileClient.get("b100133/get/excel", {
    params: props,
  });
};
